<template>
  <div class="pro-sit-fis">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="simulador" v-if="cpntConflito === false && cpntSimulador === null && cpntSelecionar === null">
        <App-Button @onClick="proSitFisTabAbrirSimulador">Simulador de casos</App-Button>
      </div>

      <div class="cabecalho" v-show="cpntConflito === false">
        <App-Filtros
        :cpntMontarCampoF="proSitFisTabOnBuscarOptionsFiltroF"
        :cpntMontarCampoO="proSitFisTabOnBuscarOptionsFiltroO"
        :cpntMontarCampoV="proSitFisTabOnBuscarOptionsFiltroV"
        :cpntFiltroPredefinido="{ f: 'ncm', o: '=', v: '' }"

        :cpntInputCoringa="{}"
        :cpntApiTabPer="cpntConflito === false && cpntSelecionar === null ? tabper : null"
        @BUSCAR='proSitFisTabBuscarLinhas'
        ref="filtros">
          <div class="botao" v-if="cpntConflito === false && cpntSelecionar === null">
            <App-Button :data-time="time" 
              :cpntId='botao.id'
              :cpntStatus='botao.status' 
              :cpntIcone='botao.icone'
              :cpntTexto='botao.texto'
              :cpntClass='botao.class'
              :cpntDisabled="botao.disabled"
              @onClick='botao.onClick'
            ></App-Button>
          </div>
        </App-Filtros>
      </div>

      <!-- SETA A TABELA -->
      <div v-if="cpntSimulador !== null" style="margin-bottom: 5px;">
        <div style="width: 20px; height: 20px; display: inline-block; background: -moz-linear-gradient( center top, #f4f1c3 5%, #ece9bd 100% ); filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#f4f1c3', endColorstr='#ece9bd'); background-color: #f4f1c3; text-decoration: none; border: 1px solid #ccc; padding: 0px; margin: 0px; vertical-align: -6px; border-radius: 2px;"></div>
        Inserindo o item na 
        <template v-if="cpntSimulador.demanda === 'dem_venda'">Venda</template>
        <template v-else-if="cpntSimulador.demanda === 'dem_compra'">Compra</template>
        <template v-else-if="cpntSimulador.demanda === 'dem_dev_cliente'">Devolução Cliente</template>
        <template v-else-if="cpntSimulador.demanda === 'dem_dev_fornecedor'">Devolução Fornecedor</template>,
        o sistema irá considerar este caso como prioridade, ou seja, este será o caso selecionado automaticamente.
      </div>

      <div class="tabela">
        <App-Tabela
        :cpntSetarFiltros="proSitFisTabSetarFiltros"
        :cpntMontarFiltros="proSitFisTabMontarFiltros"
        :cpntMontarWhere="proSitFisTabTabelaMontarWhere"
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linha"
        :cpntBotaoExportar="exportar"
        :cpntBotaoExcluir="botaoExcluir"
        :cpntBotaoEditar="botaoEditar"
        :cpntSetarValores="proSitFisTabSetarLinhas"
        :cpntMostrarMper="true"
        :cpntApiTabPerFiltros="cpntConflito === false && cpntSelecionar === null"
        :cpntApiTabPerRpp="cpntConflito === false && cpntSelecionar === null ? undefined : null"
        :cpntApiTabPerOrder="cpntConflito === false && cpntSelecionar === null ? tabPerOrder : null"
        :cpntApiTabPer="cpntConflito === false && cpntSelecionar === null ? tabper : null"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiField="field"
        :cpntApiFieldVirtual="fieldVir"
        :cpntApiOrder="order"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @TABELA_MARCAR_CHECKBOX='proSitFisTabMarcarCheckbox'
        ref="tabela">
           <!-- SETA O ICONE DA MINHA PERSONALIZAÇÃO -->
          <template slot="mper-icone" v-if="cpntConflito !== false || cpntSelecionar !== null">
            <svg class="far fa-eye"></svg>
          </template>

          <template slot="titulo" v-if="cpntSimulador !== null && linha.length >= 1">
            <b style="float: right; margin-top: 7px;">
              Total de {{ linha.length }} caso{{ linha.length >= 2 ? 's' : '' }}
            </b>
          </template>

          <!-- COLUNA DE VALORES -->
          <template v-slot:valor="{ valor, indexCV }" >
            <span v-html="proSitFisTabFormatarValor(valor, indexCV)"></span>
          </template>

          <!-- COLUNA DE INFORMAÇÕES -->
          <template v-slot:link="{ valor }" >
            <!-- :class="(cpntPDocNFEmitida === true || $store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, [ 78 ], 'or', false) === false) ? 'app-cadastro-link-disabled' : ''" -->
            <button class="btn btn-default btn-sm app-cadastro-link" @click="proSitFisTabEditarRegistroOnClick(valor)">
            <span v-html="valor"></span>
          </button>
          </template>

          <!-- COLUNA DE INFORMAÇÕES -->
          <template v-slot:info="{ linha, valor, indexCV }" >
            <span v-html="valor" :title="proSitFisTabMontarTitle(indexCV, linha)"></span>
          </template>

          <!-- COLUNA DE NCM -->
          <template v-slot:col_ncm="{ valor }">
            <span v-if="[ '', null, undefined, '0', 0 ].indexOf(valor) === -1" v-html="valor"></span>
            <span v-else>Todas (menos as exceções)</span>
          </template>

          <!-- COLUNA DE PAÍS -->
          <template v-slot:col_id_p_pais_xPais="{ linha }">
            <template v-if="[ '3', '7' ].indexOf(linha.id_cfop_ini) === -1">
              <img :src="'/img/bandeira/br.png'"  :title='"Brasil"'/>
            </template>
            <template v-else-if="[ '', null, undefined, '0', 0 ].indexOf(linha.id_p_pais) === -1">
              <img :src="'/img/bandeira/' + linha.id_p_pais_img + '.png'" :title='linha.id_p_pais_xPais'/>
            </template>
            <span v-else>Todos (menos as exceções)</span>
          </template>

          <!-- COLUNA DE DEMANDA -->
          <template v-slot:col_demanda="{ valor }">
            <span v-if="valor === 'dem_venda'">Venda</span>
            <span v-else-if="valor === 'dem_compra'">Compra</span>
            <span v-else-if="valor === 'dem_dev_cliente'">Devolução Cliente</span>
            <span v-else-if="valor === 'dem_dev_fornecedor'">Devolução Fornecedor</span>
          </template>

          <!-- COLUNA DE ESTADO -->
          <template v-slot:col_id_uf="{ linha }">
            <span v-html="linha.id_uf_chk_cfop_meu_cadastro"></span>
            <!-- <span v-if="[ '', null, undefined ].indexOf(linha.id_uf) === -1" v-html="linha.id_uf + ' - ' + linha.id_uf_estado"></span>
            <span v-else>Todas (menos as exceções)</span> -->
          </template>

          <!-- COLUNA nome -->
          <template v-slot:col_id_pro="{ linha }">
            <template v-if="[ '', null, undefined, '0', 0 ].indexOf(linha.id_pro) === -1">
              <App-Button :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" :class="$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 6 ], null, [ 12 ], null, [ 78 ], 'or', false) === false ? 'app-cadastro-link-disabled' : ''" @onClick='() => { proSitFisTabAbrirCadastro("produto", linha.id_pro) }'>
                <!-- SETA O NOME DO PRODUTO -->
                <span v-html="linha.id_pro_nome"></span>

                <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
                <b v-if='linha.id_pro_status !== "1"' v-html="'[Excluído]'"></b>
              </App-Button>
            </template>
            <span v-else>Todos (menos as exceções)</span>

          </template>

          <!-- COLUNA NOME -->
          <template v-slot:col_id_con="{ linha }">
            <!-- SETA A MENSAGEM DE TODOS -->
            <span v-if="[ '', null, undefined, '0', 0 ].indexOf(linha.id_con) !== -1">Todos (menos as exceções)</span>

            <!-- SETA O BOTÃO DO CONTATO SELECIONADO -->
            <App-Button v-else :cpntClass="[ 'btn', 'btn-default', 'bt-link-cadastro' ]" @onClick='() => { proSitFisTabAbrirCadastro("contato", linha.id_con) }'>
              <!-- COLOCA O NOME DO CONTATO -->
              <span v-html="linha.id_con_nome"></span>

              <!-- VERIFICA SE É UMA PJ E SE TEM NOME FANTASIA -->
              <span v-if='linha.id_con_pessoa === "j" && linha.id_con_empresa !== ""' v-html="' (' + linha.id_con_empresa + ')'"></span>

              <!-- VERIFICA SE O CONTATO ESTA EXCLUIDO -->
              <b v-if='linha.id_con_status !== "1"' v-html="'[Excluído]'"></b>
            </App-Button>
          </template>

          <!-- COLUNA SOBRE -->
          <template v-slot:col_icms_bc_p_r_c="{ linha }">
            <span v-if="[ '', null, undefined ].indexOf(linha.virtual_icms_bc_p_r_c_desc) === -1" v-html="linha.virtual_icms_bc_p_r_c_desc"></span>
            <span v-else-if="[ '', null, undefined ].indexOf(linha.icms_bc_p_r_c) === -1" v-html="linha.icms_bc_p_r_c"></span>
          </template>

          <!-- SETA PARA SELECIONAR O REGISTRO -->
          <template v-slot:col_selecionar="{ linha, indexL }">
            <App-Button @onClick='() => { cpntSelecionar(linha, indexL) }' :cpntClass="'btn btn-primary btn-sm'" :cpntIcone="'selecionar'"></App-Button>
          </template>
        </App-Tabela>
      </div>
    </template>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view v-if="cpntSimulador === null && cpntSelecionar === null" :cpntFecharFormulario="proSitFisTabFecharFormulario"></router-view>

    <!-- SETA A TELA DE SIT FISCAL -->
    <App-Produto-Sit-Fiscal-Formulario v-if="sit_fiscal !== null"
    :cpntId="sit_fiscal.id"
    :cpntFecharFormulario="sit_fiscal.fechar"
    ></App-Produto-Sit-Fiscal-Formulario>
  </div>
</template>

<style scoped>
</style>

<style>
  .pro-sit-fis > .simulador {
    text-align: right;
    margin-bottom: -20px;
  }

  .pro-sit-fis > .tabela > table > tbody > tr > td.col_id_p_pais_xPais > div > span > img {
    margin-right: 5px;
    width: 22px;
    height: auto;
  }
</style>

<script>
  export default {
    props: {
      cpntFiltros: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntSimulador: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntConflito: {
        required: false,
        default: function () {
          return false
        }
      },
      cpntSelecionar: {
        required: false,
        default: function () {
          return null
        }
      }
    },
    components: {
      'App-Filtros': () => import('@/components/_geral/Filtros.vue'),
      'App-Icones': () => import('@/components/rf-geral/icones/RF-Icones.vue'),

      'App-Produto-Sit-Fiscal-Formulario': () => import('@/components/produto/sit-fiscal/Produto-Sit-Fiscal-Formulario.vue')
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        checkbox: [],
        tabper: 'ProSitFiscal2',
        route: '/produto/sit-fiscal2/get',
        botao: {
          status: '',
          texto: 'Nova Situação Fiscal',
          class: [ 'btn', 'btn-info' ],
          mostrar: true,
          onClick: () => { this.$router.push({ name: 'produto_sit_fiscal_form', params: { id: 0 } }) }
        },
        colunas: [],
        linha: [],
        fazerOrdenacao: true,
        tabPerOrder: [
          { id: '-1', nome: 'Ultima Alteração',    chave: 'last_at', order: 'desc' },
          { id: '0',  nome: 'Código Decrescente',  chave: 'id',      order: 'desc' },
          { id: '1',  nome: 'Código Crescente',    chave: 'id',      order: 'asc'  },
          { id: '2',  nome: 'NCM Decrescente',     chave: 'ncm',     order: 'desc' },
          { id: '3',  nome: 'NCM Crescente',       chave: 'ncm',     order: 'asc'  },
          { id: '4',  nome: 'CFOP Decrescente',    chave: 'id_cfop', order: 'desc' },
          { id: '5',  nome: 'CFOP Crescente',      chave: 'id_cfop', order: 'asc'  }
        ],
        estruturaQueryGet: [
          [ 'type', 'countAll', 'limit', 'field', 'field_virtual', 'where', 'order' ]
        ],
        field: {},
        fieldVir: [],
        where: { aAnd: [ { f: 'status', o: '=', v: '1' } ] },
        order: {},
        simulador: false,
        botaoEditar: undefined,
        botaoExcluir: undefined,
        botaoReativar: undefined,
        exportar: undefined,
        sit_fiscal: null
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.proSitFisTabSetarStatusGeral('carregando')
      
      // INICIA O CARREGAMENTO DA TELA
      this.proSitFisTabBuscarLinhas()
    },
    methods: {
      proSitFisTabFecharFormulario: function (atualizar) {
        if (atualizar === true) {
          this.proSitFisTabBuscarLinhas()
        }
      },
      proSitFisTabBuscarLinhas: function () {
        // INICIA A VARIAVEL DOS BOTÕES
        this.botaoEditar = null
        this.botaoExcluir = null
        this.botaoReativar = null
        this.exportar = null

        // VERIFICA SE PODE EXCLUIR
        if (this.cpntConflito === false && this.cpntSelecionar === null) {
          this.botaoEditar = this.proSitFisTabEditar
          this.botaoExcluir = this.proSitFisTabExcluir
        }

        // SETA O WHERE QUE DEVE REALIZAR
        this.where = { aAnd: [ { f: 'status', o: '=', v: '1' } ] }

        // // SETA O BOTÃO EXPORTAR
        // this.exportar = {
        //   format: [ 'xlsx', 'pdf' ],
        //   search: true,
        //   field: [
        //     { id_con_nome:            'Proprietário' },
        //     { nome:                   'Nome' },
        //     { id_pet_especie_nome:    'Espécie' },
        //     { id_pet_subespecie_nome: 'Raça' },
        //     { peso:                   'Peso' },
        //     { sexo:                   'Sexo' },
        //     { castrado:               'Castrado' },
        //     { dt_nas_ptbr:            'Aniversário' },
        //     { obs:                    'Observações' },
        //     { last_user_usuario:      'Alterado por' },
        //     { last_at_ptbr:           'Última Alteração' }
        //   ]
        // }

        // REINICIA O VALOR DO CAMPO
        this.fazerOrdenacao = true

        // SETA AS COLUNAS DA TABELA
        var colunas = [
          { mPer: 3,                   chave: 'id',                               tipo: 'checkbox'                                        },
          { mPer: 1,  slot: 'link',    chave: 'id',                 nome: 'Cód'                                                           },
          { mPer: 1,                   chave: 'demanda',            nome: 'Demanda'                                                       },
          { mPer: 1,                   chave: 'id_p_pais_xPais',    nome: 'País'                                                          },
          { mPer: 1,                   chave: 'id_uf',              nome: 'Estado'                                                        },
          { mPer: 1,                   chave: 'id_con',             nome: 'Contato'                                                       },
          { mPer: 1,                   chave: 'ncm',                nome: 'NCM/SH'                                                        },
          { mPer: 1,                   chave: 'id_pro',             nome: 'Produto'                                                       },
          { mPer: 3,                   chave: 'id_caso_nome',       nome: 'Caso'                                                          },
          { mPer: 1,  slot: 'info',    chave: 'id_cfop',            nome: 'CFOP'                                                          },
          { mPer: 1,  slot: 'info',    chave: 'icms_orig',          nome: 'Origem'                                                        },
          { mPer: 1,  slot: 'info',    chave: 'icms_cst',           nome: 'CST ICMS'                                                      },
          { mPer: 0,  slot: 'info',    chave: 'icms_bc_mod',        nome: 'Mod. BC ST'                                                    },
          { mPer: 1,  slot: 'valor',   chave: 'icms_a',             nome: '% ICMS'                                                        },
          { mPer: 0,  slot: 'valor',   chave: 'icms_bc_p_r',        nome: '% Redução'                                                     },
          { mPer: 0,                   chave: 'icms_bc_p_r_c',      nome: 'Sobre'                                                         },
          { mPer: 0,  slot: 'info',    chave: 'icms_st_bc_mod',     nome: 'Mod. BC ST'                                                    },
          { mPer: 0,  slot: 'valor',   chave: 'icms_st_a',          nome: '% ICMS ST'                                                     },
          { mPer: 0,  slot: 'valor',   chave: 'icms_bc_st_p_r',     nome: 'Redução ST %'                                                  },
          { mPer: 0,  slot: 'valor',   chave: 'icms_st_bc_rt',      nome: 'BC ICMS retido por ST'                                         },
          { mPer: 0,  slot: 'valor',   chave: 'icms_st_rt',         nome: 'ICMS retido por ST'                                            },
          { mPer: 0,  slot: 'valor',   chave: 'icms_mva_p',         nome: '% MVA'                                                         },
          { mPer: 0,  slot: 'valor',   chave: 'icms_fcp_a',         nome: '% FCP'                                                         },
          { mPer: 0,  slot: 'valor',   chave: 'icms_fcp_st_a',      nome: '% FCP ST'                                                      },
          { mPer: 0,  slot: 'valor',   chave: 'icms_fcp_st_a_cf',   nome: '% Sup. pelo CF.'                                               },
          { mPer: 0,  slot: 'valor',   chave: 'icms_fcp_st_r_a',    nome: '% FCP retido por ST'                                           },
          { mPer: 0,  slot: 'valor',   chave: 'icms_fcp_st_r_bc',   nome: 'BC retido por ST'                                              },
          { mPer: 1,  slot: 'info',    chave: 'pis_cst',            nome: 'CST PIS'                                                       },
          { mPer: 1,  slot: 'valor',   chave: 'pis_a',              nome: '% PIS'                                                         },
          { mPer: 1,  slot: 'info',    chave: 'cofins_cst',         nome: 'CST COFINS'                                                    },
          { mPer: 1,  slot: 'valor',   chave: 'cofins_a',           nome: '% COFINS'                                                      },
          { mPer: 1,  slot: 'info',    chave: 'ipi_cst',            nome: 'CST IPI'                                                       },
          { mPer: 1,  slot: 'valor',   chave: 'ipi_a',              nome: '% IPI'                                                         },
          { mPer: 0,  slot: 'info',    chave: 'ipi_enq',            nome: 'IPI Enquadramento'                                             },
          { mPer: 0,  slot: 'info',    chave: 'ipi_selo',           nome: 'IPI Selo'                                                      },
        ]

        // SETA OS VALORES QUE DEVE BUSCAR NA API
        this.field = {
          id: null, 
          demanda: null,
          id_caso: { j: { nome: null } },
          id_pro: { j: { nome: null, status: null } },
          id_con: { j: { nome: null, empresa: null, pessoa: null, status: null } },
          id_p_pais: { j: { xPais: null, img: null } },
          id_uf: { j: { estado: null } },
          ncm: null,
          id_cfop_ini: null,
          id_cfop: { j: { descricao: null } },
          icms_orig: { j: { ref_icms_origem_desc: null } },
          icms_cst: { j: { ref_icms_cst_desc: null } },
          icms_a: null,
          icms_bc_mod: { j: { ref_icms_mod_bc_desc: null } },
          icms_bc_p_r: null,
          icms_bc_p_r_c: null,
          icms_st_bc_mod: { j: { ref_icms_mod_bc_st_desc: null } },
          icms_st_a: null,
          icms_bc_st_p_r: null,
          icms_st_bc_rt: null,
          icms_st_rt: null,
          icms_mva_p: null,
          icms_fcp_a: null,
          icms_fcp_st_a: null,
          icms_fcp_st_a_cf: null,
          icms_fcp_st_r_a: null,
          icms_fcp_st_r_bc: null,
          pis_cst: { j: { ref_pc_cst_desc: null } },
          pis_a: null,
          cofins_cst: { j: { ref_pc_cst_desc: null } },
          cofins_a: null,
          ipi_cst: { j: { ref_ipi_cst_desc: null } },
          ipi_a: null,
          ipi_enq: { j: { ref_ipi_enq_desc: null } },
          ipi_selo: { j: { ref_ipi_tipo: null, ref_ipi_cor: null } },
          last_at: null,
          last_user: null
        }

        // SETA OS FIELDS VIRTUAL QUE DEVE CHAMAR
        this.fieldVir = [ 'id_uf_chk_cfop_meu_cadastro', 'icms_bc_p_r_c_desc' ]

        // INCIA A VARIAVEL PARA REMOVER COLUNA
        var remover = []

        // VERIFICA SE TEM QUE REMOVER A COLUNA DE CHECKBOX
        if (this.cpntConflito === true || this.cpntSelecionar !== null) {
          colunas = colunas.splice(1, colunas.length)
        }
        
        // ADICIONA A COLUNA DE SELECIONE
        if (this.cpntSelecionar !== null) {
          // ADICIONA O VALOR QUE NÃO DEVE COLOCAR ORDENAÇÃO MPER
          this.estruturaQueryGet[0].push('sem_order_mper')

          // LIMPA A ORDENAÇÃO DA TABELA
          this.order = { last_at: 'desc' }

          // REMOVE AS COLUNAS QUE NÃO PODEM SER COPAIDAS
          remover = remover.concat([ 'id_caso_nome', 'id_pro', 'id_con', 'id_uf', 'ncm' ])

          // CRIA UMA NOVA COLUNA PARA SELECIONAR
          colunas.unshift({ mPer: 3, chave: 'selecionar', nome: 'Selecionar' })
        }

        // REMOVE A PAGINAÇÃO E A MINHA PERSONALIZAÇÃO
        if ([ '', null, undefined ].indexOf(this.cpntSimulador) === -1 || this.cpntConflito === true) {
          this.estruturaQueryGet[0].push('SemPaginacao')
        }

        // REMOVE AS COLUNAS INFORMADAS
        if (remover.length >= 1) {
          colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
        }

        // VERIFICA SE TEM ALGUM PARAMETRO PARA COLOCAR NO QUERY
        if ([ '', null, undefined ].indexOf(this.cpntSimulador) === -1) {
          // VERIFICA SE TEM WHERE A SER FEITO
          if ([ '', null, undefined ].indexOf(this.cpntSimulador.where) === -1) {
            this.where = this.cpntSimulador.where
          }

          // VERIFICA SE TEM WHERE A SER FEITO
          if ([ '', null, undefined ].indexOf(this.cpntSimulador.order) === -1) {
            this.order = this.cpntSimulador.order
          }
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR OS REGISTROS
        if ([ '', null, undefined ].indexOf(this.cpntSimulador) === -1) {
          // LIMPA A ROTA DA TELA
          this.route = null

          // SETA OS VALORES QUE DEVE BUSCAR
          var queryGet = { lot: [ this.cpntSimulador ] }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/produto/sit-fiscal2/simulador/get', 'POST', queryGet, (retorno) => {
            // PEGA OS VALORES RETORNADOS
            retorno = retorno.lot[0]

            // VERIFICA SE RECEBEU O RETORNO
            switch (retorno.code) {
              case '200':
                // VERIFICA SE O VALOR EXISTE, POIS A API NÃO RETORNA A CHAVE DATA QUANDO NÃO TEM REGISTRO
                if ([ '', null, undefined ].indexOf(retorno.data) !== -1) {
                  retorno.data = []
                }

                // SETA OS DADOS DAS LINHAS RECEBIDAS
                this.proSitFisTabSetarLinhas(retorno.data, retorno.ref.primeiro_caso)

                // SETA O STATUS DA TABELA
                this.proSitFisTabSetarStatusGeral('')
                break
            
              default: {
                // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
                const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API
        
                // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
                FUN_TRATAR_VALIDACAO_API(retorno.message, '400', {}, this, true, () => {})
                break
              }
            }
          }, this.proSitFisTabSetarStatusGeral)
        } else {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
            this.proSitFisTabReiniciar()
          } else {
            this.proSitFisTabSetarStatusGeral('')
          }
        }
      },
      proSitFisTabAbrirCadastro: function (tipo, id) {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { editar: false, tipo: tipo, id:id }
        
        // VERIFICA SE FOI ENCONTRADO O NUMERO DO REGISTRO
        if ([ '', null, undefined ].indexOf(params.id) === -1) {
          // SETA O CALLBACK QUE DEVE EXECUTAR
          params.callback = (atualizar) => {
            if (atualizar === true) {
              this.proSitFisTabBuscarLinhas()
            }
          }

          // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
          this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
        }
      },
      proSitFisTabTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = {}
        
        // CONVERTE A OPERAÇÃO RECEBIDA
        if (where.o === '%') {
          where.o = 'like'
        }

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'id_con_nome':
            if (where.o === '=') {
              retorno.where = { f: 'id_con', o: 'in', v: where.v.join() }
            } else {
              retorno.where = Object.assign(where, { m: 'contato', f: 'nome' })
            }
            break

          case 'caso':
            retorno.where = { f: 'id_caso', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_cnpj':
          case 'id_con_cpf':
            retorno.where = { m: 'contato', f: 'cnpj_cpf', o: where.o, v: where.v }
            break

          case 'id_con_telefone':
            retorno.where = { aOr: [
              { m: 'contato', f: 'tel_res', o: where.o, v: where.v },
              { m: 'contato', f: 'tel_com', o: where.o, v: where.v },
              { m: 'contato', f: 'tel_cel', o: where.o, v: where.v }
            ] }
            break
            

          case 'id_con_email':
            retorno.where = { m: 'contato', f: 'email', o: where.o, v: where.v }
            break

          case 'id_con_estado':
            retorno.where = { m: 'contato', f: 'id_estado', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_cidade':
            retorno.where = { m: 'contato', f: 'id_cidade', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_tp_con':
            retorno.where = { m: 'contato', f: 'id_tp_con', o: where.o, v: where.v.join(',') }
            break

          case 'id_con_pessoa':
            retorno.where = { m: 'contato', f: 'pessoa', o: where.o, v: where.v }
            break

          case 'id_p_pais':
            retorno.where = { f: 'id_p_pais', o: where.o, v: where.v.join(',') }
            break

          case 'id_uf':
            retorno.where = { f: 'id_uf', o: where.o, v: where.v.join(',') }
            break

          case 'id_cfop':
            retorno.where = { f: 'id_cfop', o: where.o, v: where.v.join(',') }
            break

          case 'icms_cst':
            retorno.where = { f: 'icms_cst', o: where.o, v: where.v.join(',') }
            break

          case 'demanda':
            retorno.where = { f: 'demanda', o: where.o, v: where.v }
            break

          case 'busca':
            // SETA OS DADOS QUE DEVE BUSCAR
            retorno.where = { aOr: [
              { o: 's.ft', v: where.v },
              { m: 'contato', o: 's.ft', v: where.v }
            ] }

            // REINICIA O VALOR DO CAMPO
            this.fazerOrdenacao = false
            break
        }

        // SETA O FLAG DO CAMPO
        retorno.fazerOrdenacao = this.fazerOrdenacao

        // RETORNA O VALOR MONTADO
        return retorno
      },
      proSitFisTabSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proSitFisTabReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.proSitFisTabReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      proSitFisTabSetarFiltros: function (callback, filtros, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltroSetarFiltros) === -1) {
            // VERIFICA SE TEM QUE ALTERAR O FILTRO DO CAMPO
            if ([ '', null, undefined ].indexOf(this.cpntFiltros) === -1 && ([ '', null, undefined ].indexOf(filtros) !== -1 || (Array.isArray(filtros) === true && filtros.length === 0))) {
              filtros = this.cpntFiltros
            }

            // SETA O FILTRO NA TELA
            this.$refs.filtros.cpntFiltroSetarFiltros(callback, filtros)
          } else {
            setTimeout(() => { this.proSitFisTabSetarFiltros(callback, filtros, (tentativa + 1)) }, 100)
          }
        }
      },
      proSitFisTabMontarFiltros: function (callback, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltrosMontar) === -1) {
            this.$refs.filtros.cpntFiltrosMontar(callback)
          } else {
            setTimeout(() => { this.proSitFisTabMontarFiltros(callback, (tentativa + 1)) }, 100)
          }
        }
      },
      proSitFisTabSetarLinhas: function (vetor, principal) {
        // SETA OS IDS SOLICITADOS
        for (var index in vetor) {
          if (vetor[index].id === principal) {
            vetor[index]._fundoN = 'background-tp-3'
            // vetor[index]._fundoF = 'background-tp-3'
          }
        }

        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proSitFisTabMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      proSitFisTabReativar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM REGISTRO PARA EDITAR
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente reativar o(s) pet(s) selecionados?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoReativar = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { j_id: JSON.stringify(this.checkbox) }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/pet/reativar', 'PUT', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // APRESENTA A MENSAGEM DE SUCESSO
            this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // LIMPA OS CHECKBOX SELECIONADOS
                this.checkbox = []

                // MANDA ATUALIZAR A TABELA
                this.proSitFisTabBuscarLinhas()
                break
            }

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoReativar = this.proSitFisTabReativar

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.proSitFisTabSetarStatusGeral)
        }
      },
      proSitFisTabEditar: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE TEM REGISTRO PARA EDITAR
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        // } else if (this.checkbox.length >= 2) {
        //   this.$store.state.msgWarn('WEB [406]: Só é possivel editar um pet de cada vez.', 'warning')
        } else {
          // SETA OS IDS QUE DEVE EDITAR
          var ids = this.checkbox.length === 1 ? this.checkbox[0] : window.btoa(JSON.stringify(this.checkbox))

          // REDIRENCIONA PARA TELA SOLICITADA
          this.$router.push({ name: 'produto_sit_fiscal_form', params: { id: ids } })
        }
      },
      proSitFisTabExcluir: function () {
        // REMOVE O FOCUS DE QUALQUER CAMPO
        if (document.activeElement !== document.body) {
          document.activeElement.blur()
        }

        // VERIFICA SE FOI SELECIONADO ALGUM REGISTRO
        if (this.checkbox.length === 0) {
          this.$store.state.msgWarn('WEB [406]: Selecione ao menos um registro para prosseguir.', 'warning')
        } else if (window.confirm('Deseja realmente excluir a(s) situações fiscais selecionado(s)?')) {
          // SETA O STATUS DE CARREGANDO PARA O BOTÃO
          this.botaoExcluir = 'carregando'

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // INICIA O FORMULARIO
          var formData = { j_id: JSON.stringify(this.checkbox) }

          // CHAMA FUNÇÃO PARA COMUNICAR COM API
          this.$store.state.comunicaAPI('/produto/sit-fiscal2', 'DELETE', formData, (apiSuccess) => {
            // PEGA O RETORNO RECEBIDO 
            var retorno = apiSuccess.lot[0]

            // VERIFICA O RESULTADO DA OPERAÇÃO
            switch (retorno.code) {
              case '200':
                // LIMPA OS CHECKBOX SELECIONADOS
                this.checkbox = []

                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)

                // MANDA ATUALIZAR A TABELA
                this.proSitFisTabBuscarLinhas()
                break

              default:
                this.$store.state.TRATAR_RET_LOT_API(apiSuccess)
                break
            }

            // SETA O STATUS DE CARREGANDO PARA O BOTÃO
            this.botaoExcluir = this.proSitFisTabExcluir

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, this.proSitFisTabSetarStatusGeral)
        }
      },
      proSitFisTabOnBuscarOptionsFiltroF: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // INICIA A VARIAVEL PARA ADICONAR A DEMANDA
        vetor.options = [
          { id: 'id',         nome: 'Código' },
          { id: 'demanda',    nome: 'Demanda' },
          { id: 'caso',       nome: 'Caso' },
          { id: 'id_p_pais',  nome: 'País' },
          { id: 'id_uf',      nome: 'Estado' },
          { id: 'ncm',        nome: 'NCM/SH' },
          { id: 'id_cfop',    nome: 'CFOP' },
          { id: 'icms_cst',   nome: 'CST ICMS' },
          { slot: 'contato',  group: 'Contato', mask: 'id_con' }
        ]

        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      proSitFisTabOnBuscarOptionsFiltroO: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}
        
        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f) {
          case 'id':
          case 'caso':
            vetor.options = [
              { id: 'in',    nome: 'Igual' }
            ]
            break

          case 'ncm':
            vetor.options = [
              { id: '=',    nome: 'Igual' },
              { id: '<>',   nome: 'Diferente' },
              { id: '>',    nome: 'Maior' },
              { id: '>=',   nome: 'Maior Igual' },
              { id: '<',    nome: 'Menor' },
              { id: '<=',   nome: 'Menor Igual' },
            ]
            break

          case 'id_p_pais':
          case 'id_uf':
          case 'id_cfop':
          case 'icms_cst':
          case 'demanda':
            vetor.options = [
              { id: 'in',     nome: 'Igual' },
              { id: 'notIn',  nome: 'Diferente' }
            ]
            break
        }
        
        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      proSitFisTabOnBuscarOptionsFiltroV: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f + '_' + valor.o) {
          case 'id_in':
          case 'ncm_=':
          case 'ncm_<>':
          case 'ncm_>':
          case 'ncm_>=':
          case 'ncm_<':
          case 'ncm_<=':
            vetor.tipo = 'input'
            break

          case 'id_uf_in':
            // SETA O VALOR DO CAMPO
            vetor.tipo = 'select'

            // SETA A CHAVE DE VALOR
            vetor.keyValue = 'uf'

            // SETA A CHAVE DE NOME
            vetor.keyMostra = [ 'uf', ' - ', 'estado' ]

            vetor.tab = {
              notIn: [],
              coluna: [
                { mPer: 1, chave: 'uf', nome: 'UF' },
                { mPer: 1, chave: 'estado', nome: 'Estado' },
                { mPer: 1, chave: 'botao', nome: 'Excluir' }
              ],
              linha: []
            }

            vetor.onBuscarOptions = (callback) => { callback(this.$store.state.UFs) }
            break

          case 'caso_in':
            // SETA O VALOR DO CAMPO
            vetor.tipo = 'select'

            // SETA A CHAVE DE VALOR
            vetor.keyValue = 'id'

            // SETA A CHAVE DE NOME
            vetor.keyMostra = [ 'nome' ]

            vetor.tab = {
              notIn: [],
              coluna: [
                { mPer: 1, chave: 'nome',           nome: 'Nome'      },
                { mPer: 1, chave: 'botao',          nome: 'Excluir'   }
              ],
              linha: []
            }

            vetor.onBuscarOptions = (callback) => { this.proSitFisTabOnBuscarCasos(callback) }
            break

            
          case 'id_p_pais_in':
            // SETA O VALOR DO CAMPO
            vetor.tipo = 'select'

            // SETA A CHAVE DE VALOR
            vetor.keyValue = 'cPais'

            // SETA A CHAVE DE NOME
            vetor.keyMostra = [ 'xPais', ' (', 'cPais', ')' ]

            vetor.tab = {
              notIn: [],
              coluna: [
                { mPer: 1, chave: 'bandeira_pais',  nome: 'Bandeira'  },
                { mPer: 1, chave: 'xPais',          nome: 'País'      },
                { mPer: 1, chave: 'botao',          nome: 'Excluir'   }
              ],
              linha: []
            }

            vetor.onBuscarOptions = (callback) => { this.proSitFisTabOnBuscarPais(callback) }
            break

          case 'id_cfop_in':
          case 'id_cfop_notIn':
            // SETA O VALOR DO CAMPO
            vetor.tipo = 'select'

            // SETA A CHAVE DE VALOR
            vetor.keyValue = 'cfop'

            // SETA A CHAVE DE NOME
            vetor.keyMostra = [ 'cfop', ' - ', 'descricao' ]

            vetor.tab = {
              notIn: [],
              coluna: [
                { mPer: 1, chave: 'cfop', nome: 'CFOP' },
                { mPer: 1, chave: 'descricao', nome: 'Descrição' },
                { mPer: 1, chave: 'botao', nome: 'Excluir' }
              ],
              linha: []
            }

            vetor.onBuscarOptions = (callback) => { this.proSitFisTabOnBuscarCFOP(callback) }
            break

          case 'icms_cst_in':
          case 'icms_cst_notIn':
            // SETA O VALOR DO CAMPO
            vetor.tipo = 'select'

            // SETA A CHAVE DE VALOR
            vetor.keyValue = 'cst'

            // SETA A CHAVE DE NOME
            vetor.keyMostra = [ 'cst', ' - ', 'descricao' ]

            vetor.tab = {
              notIn: [],
              coluna: [
                { mPer: 1, chave: 'cst', nome: 'CST' },
                { mPer: 1, chave: 'descricao', nome: 'Descrição' },
                { mPer: 1, chave: 'botao', nome: 'Excluir' }
              ],
              linha: []
            }

            vetor.onBuscarOptions = (callback) => { this.proSitFisTabOnBuscarCSTICMS(callback) }
            break

          case 'demanda_in':
          case 'demanda_notIn':
            // SETA O VALOR DO CAMPO
            vetor.tipo = 'select'

            // SETA A CHAVE DE VALOR
            vetor.keyValue = 'id'

            // SETA A CHAVE DE NOME
            vetor.keyMostra = [ 'nome' ]

            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: 'dem_venda',            nome: 'Venda' },
              { id: 'dem_dev_cliente',      nome: 'Devolução Cliente' },
              { id: 'dem_compra',           nome: 'Compra' },
              { id: 'dem_dev_fornecedor',   nome: 'Devolução Fornecedor' },
            ]

            // SETA O VALOR SELEICONADO
            vetor.value = '1'
            break
        }
        
        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      proSitFisTabOnBuscarCasos: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA OS CAMPOS QUE DEVE RETORNAR
          queryGet.field = { id: null, nome: null }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'status', o: '=', v: '1' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/produto/sit-fiscal/caso/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisTabOnBuscarCasos(callback, id, Number(apiSuccess.countAll), registros)
          }, this.proSitFisTabSetarStatusGeral)
        } else {
          callback(registros)
        }
      },
      proSitFisTabOnBuscarPais: function (callback, id, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 } }

          // SETA O NOME DOS CAMPOS
          queryGet.field = { cPais: null, xPais: null, img: null }

          // ORDENA 
          queryGet.order = { xPais: 'asc' }

          // SETA O STATUS DO VENDEDOR
          // queryGet.where = { f: 'cPais', o: '<>', v: '1058' }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-pais/get', 'POST', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisTabOnBuscarPais(callback, id, Number(apiSuccess.countAll), registros)
          }, this.proSitFisTabSetarStatusGeral)
        } else {
          // SETA O CAMINHO DA IMAGEM DO BANCO
          for (var indexR in registros) {
            registros[indexR]._img = '/img/bandeira/' + registros[indexR].img + '.png'
          }

          // EXECUTA A FUNÇÃO CALLBACK
          callback(registros)
        }
      },
      proSitFisTabOnBuscarCSTICMS: function (callback, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { ref_icms_cst: { a: 'cst' }, ref_icms_cst_desc: { a: 'descricao' } } }

          // SETA O WHERE QUE DEVE REALIZAR
          queryGet.where = { f: 'ref_icms_rt_id', o: '=', v: (this.$store.state.licenca.rt_id === '3' ? '3' : '1,2') }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-icms-cst/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisTabOnBuscarCSTICMS(callback, Number(apiSuccess.countAll), registros)
          }, this.proSitFisTabSetarStatusGeral)
        } else {
          callback(registros)
        }
      },
      proSitFisTabOnBuscarCFOP: function (callback, total = null, registros = []) {
        if (total === null || total < registros.length) {
          // MONTA O QUERY GET
          var queryGet = { type: 'list', limit: { row: registros.length, qty: 1000 }, field: { cfop: null, descricao: null } }
  
          // FAZ A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/referencia/pro-cfop/get/', 'GET', queryGet, (apiSuccess) => {
            // JUNTA OS VALORES RECEBIDOS
            registros = registros.concat(apiSuccess.data)

            // CHAMA A FUNÇÃO PARA BUSCAR OS PROXIMOS REGISTROS
            this.proSitFisTabOnBuscarCFOP(callback, Number(apiSuccess.countAll), registros)
          }, this.proSitFisTabSetarStatusGeral)
        } else {
          callback(registros)
        }
      },
      proSitFisTabMontarTitle: function (chave, linha) {
        switch (chave) {
          case 'id_cfop':
            return linha.id_cfop + ' - ' + linha.id_cfop_descricao

          case 'icms_bc_mod':
            return linha.icms_bc_mod + ' - ' + linha.icms_bc_mod_ref_icms_mod_bc_desc

          case 'icms_st_bc_mod':
            return linha.icms_st_bc_mod + ' - ' + linha.icms_st_bc_mod_ref_icms_mod_bc_st_desc

          case 'icms_cst':
            return linha.icms_cst + ' - ' + linha.icms_cst_ref_icms_cst_desc

          case 'pis_cst':
            return linha.pis_cst + ' - ' + linha.pis_cst_ref_pc_cst_desc

          case 'cofins_cst':
            return linha.cofins_cst + ' - ' + linha.cofins_cst_ref_pc_cst_desc

          case 'icms_orig':
            return linha.icms_orig + ' - ' + linha.icms_orig_ref_icms_origem_desc

          case 'ipi_cst':
            return linha.ipi_cst + ' - ' + linha.ipi_cst_ref_ipi_cst_desc

          case 'ipi_enq':
            return linha.ipi_enq + ' - ' + linha.ipi_enq_ref_ipi_enq_desc

          case 'ipi_selo':
            return linha.ipi_selo + ' - ' + linha.ipi_selo_ref_ipi_cor + ' - ' + linha.ipi_selo_ref_ipi_tipo
        }
      },
      proSitFisTabFormatarValor: function (valor) {
        // // VERIFICA SE O CAMPO TEM VALOR PADRÃO
        // if (valor === '' && [ 'icms_a', 'icms_bc_p_r', 'icms_st_a', 'icms_bc_st_p_r', 'icms_st_bc_rt', 'icms_st_rt', 'icms_mva_p', 'icms_fcp_a', 'icms_fcp_st_a', 'icms_fcp_st_a_cf', 'icms_fcp_st_r_a', 'icms_fcp_st_r_bc', 'pis_a', 'cofins_a', 'ipi_a' ].indexOf(chave) !== -1) {
        //   valor = null
        // }

        // CASO NÃO TENHA VALOR, SETA O VALOR 0,00
        switch (valor) {
          case '':
            valor = ''
            break

          case null:
          case undefined:
            valor = '0,00'
            break

          default:
            valor = this.$store.state.FUN_MASK_VALOR('valorMoeda', valor)
            break
        }

        // RETORNA O VALOR MONTADO
        return valor
      },
      proSitFisTabAbrirSimulador: function () {
        // SETA OS PARAMETROS QUE SERÁ ENVIADO
        var params = { tipo: 'SIMULADOR_SIT_FISCAL' }

        // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
        this.$store.commit('SET_ABRIR_CADASTRO_VET', params)
      },      
      proSitFisTabEditarRegistroOnClick: function (valor) {
        this.sit_fiscal = { id: valor, fechar: (atualizar) => {
          // SETA FECHA O FORMULARIO
          this.sit_fiscal = null

          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // MANDA ATUALIZAR A TELA
          if (atualizar === true) {
            this.proSitFisTabBuscarLinhas()
          }
        } }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
    }
  }
</script>
